
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["logo-svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M500 50c-165 0-321 69-400 121 0 432 194 636 400 772 206-136 400-340 400-772-79-52-235-121-400-121z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M500 81c-151.3 0-294.4 63.3-366.9 111 0 396.2 177.9 583.3 366.9 708 188.9-124.7 366.9-311.8 366.9-708C794.4 144.3 651.3 81 500 81z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M627.4 489.3c-6-26.8 14.5-52.3 42-52.3H750s-29-100-137-102c-2.2-2.4-4.1-4.8-5.6-7.3-15.2-24.1-41.7-38.7-70.2-38.7H384c18 131-46 312.6-87 371 101 137 203 198 203 198s102-61 203-198c-20.6-29.3-49.9-88.7-72.1-157.6-1.2-3.8-2.4-8.3-3.5-13.1zM489 351s24-38 53-38c18 0 30 7 35 22-35-3-88 16-88 16zM526 239c-28 0-26-31-26-42h12v-23c-23-14-40-46-40-46s-17 32-40 46v23h12c0 11 2 42-26 42-23.7 0-67-67-67-67s24 47 24 94h194c0-47 24-94 24-94s-43.3 67-67 67z"}})])
          )
        }
      }
    